// extracted by mini-css-extract-plugin
module.exports = {"legend":"styles_legend__17u3L","labelText":"styles_labelText__2u9Z9"};